// 视觉主题选择器共用件（044 T3.2）：9 组风格标签 + 双色 chip 取色。
// NewProject 表单与 Editor 右栏共用（同一顺序、同一取色），避免两处漂移。
import { hex, type ThemeDef } from "./tokens.generated";

export interface StyleGroup { id: string; label: string }

/** 风格分组（9 组 16 主题；分组名与 043 §2 G1-G4 与第二批命名一致） */
export const STYLE_GROUPS: StyleGroup[] = [
  { id: "swiss", label: "瑞士国际主义" },
  { id: "magazine", label: "电子杂志风" },
  { id: "luxe", label: "暗夜轻奢" },
  { id: "consult", label: "商务咨询" },
  { id: "brutal", label: "粗野报纸" },
  { id: "term", label: "终端磷光" },
  { id: "report", label: "研报深墨" },
  { id: "ink", label: "水墨朱印" },
  { id: "memphis", label: "孟菲斯" },
];

/** 双色 chip 取色（第一色=accent 系、第二色=底纸系；CSS 用色补 #）。
 *  swiss=accent+纸灰 / magazine=ink+paper / luxe·consult·brutal=accent+纸底
 *  / term·report=accent+纯黑 / ink=朱红+暖纸 / memphis=橙+蓝（5 色轮用代表） */
export function chipColors(t: ThemeDef): [string, string] {
  switch (t.style) {
    case "swiss": return [hex(t.accent), hex(t.grey.paper)];
    case "magazine": return [hex(t.ink), hex(t.paper)];
    case "luxe": return [hex(t.accent), hex(t.inkDeep)];
    case "consult": return [hex(t.accent), hex(t.paper)];
    case "brutal": return [hex(t.accent), hex(t.paper)];
    case "term": return [hex(t.accent), hex(t.inkDeep)];
    case "report": return [hex(t.accent), hex(t.inkDeep)];
    case "ink": return [hex(t.accent), hex(t.paper)];
    case "memphis": return [hex(t.accent), hex(t.accentBlue)];
  }
}
